import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { sunidhiPlugin } from './sunidhiapp';
import router from './router';
import Multiselect from 'vue-multiselect';
 
 
import '@/assets/styles/pwa-styles.min.css';
 
import '@/assets/styles/vue-multiselect.min.css';
import '@mdi/font/css/materialdesignicons.css';
import '@mdi/font/css/materialdesignicons.min.css';
 
// import '@/assets/styles/style.css';
// import '../node_modules/vuetify/dist/vuetify.min.css';
 
import '@/assets/styles/vuetify.min.css';
import '@/assets/styles/index.css';
import jic from './customJs/JIC.min.js';
import './customJs/canvasjs.min.js';
import './customJs/compressjs.js';
import $ from 'jquery';
import VueCookies from "vue-cookies";
import '@/services/api';
 
Vue.use(VueCookies);// Register Globally
 
 
Vue.config.productionTip = false;
// Vue.prototype.$sunidhi = sunidhi;
Vue.use(sunidhiPlugin);
Vue.component('vue-multiselect', Multiselect);
Vue.use(jic);
 
Vue.directive('hide', {
  inserted: function (el, binding) {
    el.style.display = binding.value ? 'none' : '';
  }
});
 
router.beforeEach((to, from, next) => {
  // Push a new state to history to override the previous state
  window.history.pushState(null, '', window.location.href);
  next();
});
 
window.addEventListener('popstate', (event) => {
  // Push another state to prevent going back
  window.history.pushState(null, '', window.location.href);
});
 
 
new Vue({
  vuetify,
  router,
  render: h => h(App),
  mounted() {
 
    // Continuously push a new history state to block back button
    history.pushState(null, '', document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, '', document.URL);
    });
 
 
 
    window.addEventListener('beforeunload', (event) => {
      event.preventDefault();
      event.returnValue = '';
    });
  }
}).$mount('#app')
 
$(document).ready(function() {
  console.log('jQuery is ready');
});
 
// Vue.$cookies.set("user-consent", "accepted", "30d"); // Set a cookie
// console.log(Vue.$cookies.get("user-consent")); // Get a cookie
 
// VueCookies.set("user-consent", "accepted"); // No expiry set = session cookie
// VueCookies.set("user-consent", "rejected"); // No expiry set = session cookie
 